import { ObservableArray, View } from "binder"
import { IPhone, PhoneInputViewModel } from "./phoneInput-viewModel"

export class PhoneInputView extends View<PhoneInputViewModel>{
    GetViewUniqueId(): string {
        return "V-CF347272-37A4-4CBE-BA16-906EFF3F9375"
    }
    loadHtml(): string {
        let element = require('./phoneInput.html').default;
        let style = require('./phoneInput.less');
        return element;
    }
    constructor() {
       super();
    }

    public set writtenText(v: string) { this._writtenText = v; } public get writtenText(): string { return this._writtenText;} private _writtenText: string;
    public set phones(v: ObservableArray<IPhone>) { this._phones = v; } public get phones(): ObservableArray<IPhone> { return this._phones;} private _phones: ObservableArray<IPhone>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async confirm(){
        this.dataContext.confirm();
    }
}
